<!--
******************************************************************************************************
Program ID:
Author:             Dickion To
Date:               2019-01-21
Purpose:            A module for providing common hander
Inputs:
Returns:
Copyright:          All the intellectual rights belong to  Airport Authority Hong Kong
------------------------------------------------------------------------------------------------------
Revision History
------------------------------------------------------------------------------------------------------
Initial Version:    2019-01-21
******************************************************************************************************
-->
<template>
  <header>
  <b-navbar toggleable="md" type="dark" variant="primary" :sticky="true">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand>
      <img class="d-sm-inline-block d-none align-center mr-5 aa-logo" src='@/assets/aa_logo_white.png'/>
        <span v-if='!title' class='d-none d-sm-inline-block'>Airport GIS</span>
        <span v-if='title' class='d-none d-sm-inline-block'>{{title}}</span>
        <span v-if='$route.meta.title' class='d-none d-sm-inline-block'> - </span>
        <span v-if='$route.meta.title'>{{$route.meta.title}}</span>
    </b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto">
      <user :userManagementVisible="userManagementVisible"/>
      <a v-if='helpVisible' class='btn btn-primary' target="AGISHelp" :href="helpUrl">
        <span class='esri-icon-question'></span> 
      </a>
      <b-nav-item 
        v-bind:key="subMenuItem.routeName"
        v-for="subMenuItem in subMenuItems"
        class='d-block d-sm-block d-md-none' 
        :to="{name: subMenuItem.routeName}" > {{subMenuItem.title}}</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  </header>
</template>

<script>
import User from '@/components/ui-components/User';

export default {
  name: 'agis-header',
  components: {
      user: User
  },
  props: {
    userManagementVisible: {
      default: true,
      type: Boolean
    },
    helpVisible: {
      default: true,
      type: Boolean
    },
    helpUrl: {
      default: '/agis-web-client-doc',
      type: String
    },
    title: {
      default: 'Airport GIS',
      type: String
    },
    subMenuItems: {
      defatul: [],
      type: Array
    }
  },
  created: function () {

  },
  data:function(){
      return {
      }
  },
  mounted:function() {
    this.image = this.baseUrl + this.image;
    // console.log(this.helpUrl);
  },
  methods:{
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui-components/AGISHeader.vue